export const formatNaira = (amount: number) => {
  return `₦${amount.toLocaleString('en-NG')}`;
};

// Convert Naira input to kobo for database storage
export const toKobo = (nairaAmount: number) => {
  return nairaAmount;
};

// Convert kobo from database to Naira for display
export const toNaira = (koboAmount: number) => {
  return koboAmount;
};

// Parse price input to remove leading zeros and non-numeric characters
export const parsePrice = (value: string) => {
  // Remove non-numeric characters
  const cleanValue = value.replace(/[^\d]/g, '');
  // Return 0 if empty string
  return cleanValue === '' ? '0' : cleanValue;
};